var _style, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#ED5565;}\n\t.st1{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 40,
    cy: 40,
    r: 40
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-8.7,0h97.4c6,0,10.8,4.9,10.8,10.9v58.2c0,6-4.8,10.9-10.8,10.9H-8.7c-6,0-10.8-4.9-10.8-10.9V10.9 C-19.5,4.9-14.7,0-8.7,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.3,23.2L51.3,23.2c-1-0.5-2-0.9-3-1.3c-9.8-3.2-20.4,2.2-23.7,12.2c-0.6,1.9-1,3.9-1,5.8 c-0.1,1.9,0.2,3.9,0.7,5.8c2.8,10,13.2,15.8,23.1,12.8c1-0.3,2-0.7,3-1.2l0.1,0c0.3-0.1,0.7,0.1,0.8,0.4c0.1,0.3,0,0.6-0.3,0.7 c-2.4,2-5.2,3.5-8.3,4.4c-12.5,3.7-25.5-3.5-29-16.1c-0.7-2.3-0.9-4.7-0.9-7c0.1-2.3,0.4-4.7,1.2-7c4.1-12.5,17.4-19.4,29.8-15.3 c3.1,1,5.8,2.6,8.1,4.6c0.2,0.2,0.3,0.4,0.2,0.7C52,23.1,51.6,23.3,51.3,23.2z M64.5,38.5L61,41.3c-0.9,0.7-1.4,2.3-1.1,3.4 l0.9,3.8c0.3,1.1-0.3,1.5-1.2,0.9L56,47.1c-1-0.7-2.6-0.7-3.5,0l-3.7,2.4c-1,0.7-1.5,0.2-1.2-0.9l1.2-4.2c0.3-1.1-0.1-2.7-1-3.5 l-3-2.8c-0.8-0.8-0.6-1.5,0.6-1.4l4.4,0c1.2,0,2.4-0.9,2.8-2l1.5-4.6c0.4-1.1,1-1.1,1.3,0l1.5,4.7c0.4,1.1,1.6,2.1,2.8,2.1L64,37 C65.2,37.1,65.4,37.7,64.5,38.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.07dbce9cf6d8b8c67f7e0c6376cd4ae4.svg";
export { ForwardRef as ReactComponent };